import * as React from "react";

export type ActionBarProps = {
  incomingLoading?: boolean;
  cleanCopyLoading?: boolean;
  onSaveAndUpload?: () => void;
  onCleanCopy?: () => void;
  error?: string;
};

export const ActionBar: React.FC<ActionBarProps> = ({
  incomingLoading,
  cleanCopyLoading,
  onSaveAndUpload,
  onCleanCopy,
  error,
}) => {
  const busy = Boolean(incomingLoading || cleanCopyLoading);

  return (
    <div className="plugin-action-bar">
      <div className="plugin-action-bar__row">
        <button
          type="button"
          className="plugin-action-btn"
          disabled={busy || !onSaveAndUpload}
          aria-busy={incomingLoading || undefined}
          onClick={onSaveAndUpload}
        >
          <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.2" strokeLinecap="round" strokeLinejoin="round" aria-hidden>
            <path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4" />
            <polyline points="17 8 12 3 7 8" />
            <line x1="12" y1="3" x2="12" y2="15" />
          </svg>
          {incomingLoading ? "Uploading…" : "Save & upload"}
        </button>
        <button
          type="button"
          className="plugin-action-btn"
          disabled={busy || !onCleanCopy}
          aria-busy={cleanCopyLoading || undefined}
          onClick={onCleanCopy}
        >
          <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.2" strokeLinecap="round" strokeLinejoin="round" aria-hidden>
            <rect x="9" y="9" width="13" height="13" rx="2" ry="2" />
            <path d="M5 15H4a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2h9a2 2 0 0 1 2 2v1" />
          </svg>
          {cleanCopyLoading ? "Generating…" : "Clean copy"}
        </button>
      </div>
      {error ? <div className="plugin-action-bar__error" role="alert">{error}</div> : null}
    </div>
  );
};
